<template>
  <div class="chat-bubble bot extra-message" :id="this.messageId + '-extra-message'">
    <div class="bot-profilepic">
      <i class="mm-icon favicon-mm-stitches">
        <svg role="presentation"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="icon"
          aria-hidden="true">
          <use href="#favicon-mm-stitches" />
        </svg>
      </i>
    </div>
    <div class="message">
      <p class="text">{{ this.extraMessage.text }}</p>
      <p class="subtext" v-if="this.extraMessage.subtext">{{ this.extraMessage.subtext }}</p>

      <div class="support-links" v-if="this.extraMessage.newsletter || (this.extraMessage.ctaLabel && this.extraMessage.ctaLink)">
        <button v-if="this.extraMessage.newsletter" @click="scrollToNewsletter()" class="mm-button">{{this.extraMessage.ctaLabel}}</button>
        <a v-if="this.extraMessage.ctaLabel && this.extraMessage.ctaLink" :href="this.extraMessage.ctaLink" target="_blank" class="mm-button">{{this.extraMessage.ctaLabel}}</a>
      </div>

      <template v-if="this.extraMessage.social">
        <div class="section-icon-social">
          <a href="http://instagram.com/maisonmargiela" target="_blank" rel="noopener nofollow" class="icon icon--ig"></a>
          <a href="https://twitter.com/margiela" target="_blank" rel="noopener nofollow" class="icon icon--x"></a>
          <a href="http://www.youtube.com/MARGIELAtube" target="_blank" rel="noopener nofollow" class="icon icon--yt"></a>
          <a href="https://www.maisonmargiela.com/Social/WeChatPage" target="_blank" rel="noopener nofollow" class="icon icon--wc"></a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: [
    'messageId',
    'totalMessages',
    'extraMessage'
  ],
  emits: [
    'newsletterClicked'
  ],
  methods: {
    scrollToNewsletter(){
      const newsletterSectionElement = document.querySelector('.section-newsletter-footer');

      this.$emit('newsletterClicked');
      if (newsletterSectionElement) {
        newsletterSectionElement.scrollIntoView();
      }
    }
  }
}
</script>